/**
 * OverrideModal - Modal for overriding attendance status
 */
import { useState, useEffect } from "react";
import { CheckCircle2, XCircle, X, Save, Loader2 } from "lucide-react";

export const OverrideModal = ({ isOpen, onClose, child, date, currentStatus, onSave, saving }) => {
  const [newStatus, setNewStatus] = useState(currentStatus);
  
  useEffect(() => {
    setNewStatus(currentStatus);
  }, [currentStatus]);
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-4 max-w-sm w-full shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-gray-800">Override Kehadiran</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-1">Kanak-kanak:</p>
          <p className="font-medium text-gray-800">{child?.name}</p>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-1">Tarikh:</p>
          <p className="font-medium text-gray-800">{date}</p>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">Status Kehadiran:</p>
          <div className="flex gap-2">
            <button
              onClick={() => setNewStatus(true)}
              className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all ${
                newStatus === true 
                  ? 'bg-green-500 text-white shadow-lg' 
                  : 'bg-green-50 text-green-600 hover:bg-green-100'
              }`}
            >
              <CheckCircle2 className="w-5 h-5 mx-auto mb-1" />
              Hadir
            </button>
            <button
              onClick={() => setNewStatus(false)}
              className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all ${
                newStatus === false 
                  ? 'bg-red-500 text-white shadow-lg' 
                  : 'bg-red-50 text-red-600 hover:bg-red-100'
              }`}
            >
              <XCircle className="w-5 h-5 mx-auto mb-1" />
              Tidak Hadir
            </button>
          </div>
        </div>
        
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
          <p className="text-xs text-yellow-700">
            Override ini tidak akan mengubah log harian. Hanya rekod kehadiran akan dikemas kini.
          </p>
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-600 font-medium text-sm"
          >
            Batal
          </button>
          <button
            onClick={() => onSave(newStatus)}
            disabled={saving}
            className="flex-1 py-2 bg-purple-500 hover:bg-purple-600 rounded-lg text-white font-medium text-sm flex items-center justify-center gap-2"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
};
